import axios from "axios";
import { Base_URL } from "../url";

export const fetchEmployeeTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/EmployeeTypeMaster/GetAllEmployeeTypes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching employee types!";
  }
};

export const downloadEmployeeTypesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/EmployeeTypeMaster/DownloadEmployeeTypesExcel`,
      null, 
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading employee types data!";
  }
};